export const version = '2.39.7';
//# sourceMappingURL=version.js.map